import {
  Zap,
  Banknote,
  Dumbbell,
  ShoppingBag,
  Boxes,
  Tag,
  Megaphone,
  Handshake,
} from 'lucide-react';
import HubPage from '../components/ui/HubPage';

// Hub Negocio (PR-UX1-REDO): agrupa todo lo vendible y su operativa de pedidos.
// Las páginas destino siguen montadas en sus rutas; aquí solo se enlazan como
// tarjetas. GYM es a su vez un sub-hub con pestañas internas.

export default function NegocioPage() {
  return (
    <HubPage
      subtitle="Catálogo, bonos, tienda, inventario, descuentos y patrocinios."
      cards={[
        {
          to: '/bonos',
          icon: Zap,
          title: 'Bonos y créditos',
          description: 'Catálogo de bonos de sesiones y sus créditos.',
          testid: 'hub-card-bonos',
        },
        {
          to: '/bonos-manuales',
          icon: Banknote,
          title: 'Bonos manuales',
          description: 'Conceder o ajustar créditos a mano.',
          testid: 'hub-card-bonos-manuales',
        },
        {
          to: '/gym',
          icon: Dumbbell,
          title: 'Preparación Física',
          description: 'Módulo de preparación física: ejercicios y asignaciones.',
          testid: 'hub-card-gym',
        },
        {
          to: '/tienda',
          icon: ShoppingBag,
          title: 'Tienda',
          description: 'Productos físicos, matrículas, servicios y packs.',
          testid: 'hub-card-tienda',
        },
        {
          to: '/inventario',
          icon: Boxes,
          title: 'Inventario',
          description: 'Existencias por talla y variante, y lo que hay que pedir.',
          testid: 'hub-card-inventario',
        },
        {
          to: '/descuentos',
          icon: Tag,
          title: 'Descuentos',
          description: 'Códigos de descuento propios para el checkout.',
          testid: 'hub-card-descuentos',
        },
        {
          to: '/patrocinadores',
          icon: Megaphone,
          title: 'Patrocinadores',
          description: 'Patrocinadores mostrados en la app del alumno.',
          testid: 'hub-card-patrocinadores',
        },
        {
          to: '/colaboradores',
          icon: Handshake,
          title: 'Colaboradores',
          description: 'Colaboradores (solo logo) mostrados en la app del alumno.',
          testid: 'hub-card-colaboradores',
        },
      ]}
    />
  );
}
